module.exports = __webpack_public_path__ + "img/b3a7934.jpg";